
















import Vue from "vue";
import AppDialog from "~/components/AppDialog.vue";

export default Vue.extend({
  components: {
    AppDialog
  },
  data() {
    return {
      name: ''
    }
  },
  methods: {
    async handleAdd() {
      // Payload will have empty values that get built off of when you travel to the edit page
      let payload = {
        name: this.name,
        configData: [],
        constants: [],
        variables: [],
      }

      try {
        const res = await this.$axios.post(`anonymization-config/`, payload)
        const config = res.data;
        await this.$router.push(`/anonymization/${config.id}`);
      } catch (e) {
        this.$toast.error(e.response.data.message);
      } 
    }
  }
})
